import {Map as olMap, View as olView} from 'ol'
import {Tile as ollayerTile} from 'ol/layer'
import {OSM, XYZ as olsourceXYZ} from 'ol/source'
import 'ol-proj'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import { Renderer } from './Renderer'
import Style from 'ol/style/Style'
import { Styles } from '@/Styles'

export class OSMRenderer extends Renderer<OSM> {
  map: olMap;
  layer: ollayerTile<OSM>;
  projection = "EPSG:3857";
  
  static type = 'osm'

  GetType(): string {
      return OSMRenderer.type
  }

  static IsValidForExtent(latLngExtent: Extent) {
    return true
  }

  constructor(type: string, element: string, extentLatLng: Extent) {
    super(type)
    this.layer = new ollayerTile({
      source: new OSM({})
    });
    //this.layer
    this.map = this.CreateMap(element, extentLatLng);
  }

  CreateView(centre: Coordinate): olView {
    return new olView({
      projection: this.projection,
      center: centre,
      zoom: 7,
      maxZoom: 20
    });
  }
}